import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette } from "@fortawesome/free-solid-svg-icons";

export const ActionBarDesignTab = ({ setIsCustomThemeOpen }) => (
  <>
    <div className="text-xs text-gray-500">
      Choose a theme according to your business branding
    </div>
    <button
      className={"premium-icon-btn actionbar-btn actionbar-btn-horizontal"}
      onClick={() => setIsCustomThemeOpen(true)}
    >
      <span className={"actionbar-btn-inner-horizontal"}>
        <FontAwesomeIcon icon={faPalette} className="actionbar-btn-icon" />
        <span className="actionbar-btn-text">Select Theme</span>
      </span>
    </button>
  </>
);
